import { Widgets } from '@modules/common/constants';
import { useMemo } from 'react';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { useSearchStore } from '../store/searchStore';
import { getUseInQuantifyV2Link } from '../utils';

interface useGetTrendingReasonsLinkForQuantifyOptions {
  shouldShowCooccurringDataPoints?: boolean;
}

export const useGetTrendingReasonsLinkForQuantify = ({
  shouldShowCooccurringDataPoints,
}: useGetTrendingReasonsLinkForQuantifyOptions) => {
  const baseCondition = useSearchStore(({ query }) => query?.baseCondition);
  const duration = useSearchStore(({ query }) => query?.duration);
  const whereClause = useSearchStore(({ query }) => query?.whereClause);

  const quantifyLink = useMemo(() => {
    return getUseInQuantifyV2Link({
      baseCondition,
      duration,
      shouldShowCooccurringDataPoints,
      whereClause: whereClause ?? EmptyWhereClause,
      widget: Widgets.Reason,
    });
  }, [baseCondition, duration, whereClause, shouldShowCooccurringDataPoints]);

  return quantifyLink;
};
